
import { inject } from "vue";
import { ConciergeService } from "./concierge";
import { StandortService } from "./standort";
import { ConfigurationService } from "./configuration";
import { DatenjahrService } from "./datenjahr";
import { FeatureService } from "./features";
import { StorageService } from "./storage";
import { BerichtService } from "./bericht";

export const ServicesSymbol = Symbol();

export interface Services {
  Concierge: ConciergeService;
  Standort: StandortService;
  Configuration: ConfigurationService;
  Datenjahr: DatenjahrService;
  Features: FeatureService;
  Storage: StorageService;
  Berichte: BerichtService;

  SetToken(token:string | undefined): void;
}

export class Services implements Services {
  constructor(apiHost: string, token: string){
    this.Concierge = new ConciergeService(`${apiHost}/concierge/`, token);
    this.Standort = new StandortService(`${apiHost}/standort/`, token);
    this.Configuration = new ConfigurationService(`${apiHost}/configuration/`, token);
    this.Datenjahr = new DatenjahrService(`${apiHost}/datenjahr/`, token);
    this.Features = new FeatureService(`${apiHost}/features/`, token);
    this.Storage = new StorageService(`${apiHost}/storage/`, token);
    this.Berichte = new BerichtService(`${apiHost}/bericht/`, token);
  }

  SetToken(token:string | undefined): void {
    this.Concierge.Token = token;
    this.Standort.Token = token;
    this.Configuration.Token = token;
    this.Datenjahr.Token = token;
    this.Features.Token = token;
    this.Storage.Token = token;
    this.Berichte.Token = token;
  }
}

export const useServices = () => {
  const services = inject(ServicesSymbol) as Services

  return services
}